export const bookingCallingReceptionEndpoint = '/berths/booking/calling_reception' as const
